import React from 'react';
import PropTypes from 'prop-types';

import {TunnelStatus} from '@utils/tableHelpers';

const TunnelOption = ({tunnel, vtdTunnel}) => (
    <div>
        {vtdTunnel?.name ? (
            <span>{`${tunnel.name} - ${vtdTunnel.name} (${vtdTunnel.id})`}</span>
        ) : (
            <span>{tunnel.name}</span>
        )}
        <span className='--marginLeft-1-5em'><TunnelStatus isStarted={!!vtdTunnel?.started} /></span>
    </div>
);

TunnelOption.propTypes = {
    tunnel: PropTypes.object,
    vtdTunnel: PropTypes.object,
};

export default TunnelOption;
